import { defineStore } from 'pinia'
interface AssineChoiceState {
  choiceId: number
  choiceType: string
}
export const assineChoiceStore = defineStore('assineChoice', {
  state: () => ({
    choiceId: 0 as number,
    choiceType: '' as string
  }),
  actions: {
    async setAssineChoice(payload: AssineChoiceState) {
      this.choiceId = payload.choiceId
      this.choiceType = payload.choiceType
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'assineChoice',
        storage: sessionStorage,
      },
    ],
  }
})